<template>
  <div>
    <TextFormGroup
        v-model="data.url"
        name="url"
        label="URL"
        :error="(errors.url || [])[0]"
        help-text="The Buzzsprout URL, eg. https://www.buzzsprout.com/541567/13154216-fra-erp-til-s-op-med-et-forecast-og-demandsystem.js"
    />
  </div>
</template>

<script>
import TextFormGroup from "../../../../vendor/forms/FormGroups/Block/Text.vue";

export default {
  components: { TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
